import { PATHS } from "src/core/constants";

export const getFabricRoute = (
  fabricId?: string,
  tab: string | undefined = PATHS.SUMMARY
): string => {
  return `/${PATHS.FABRIC}/${fabricId}/${tab}`;
};

export const getSwitchRoute = (
  fabricId?: string,
  nodeId?: string,
  tab: string = PATHS.SUMMARY
): string => {
  return `${getFabricRoute(fabricId, PATHS.CHASSIS)}/${nodeId}/${tab}`;
};

export const getPortRoute = (
  fabricId?: string,
  nodeId?: string,
  portId?: string
): string => {
  return `${getSwitchRoute(fabricId, nodeId, PATHS.PORT)}/${portId}`;
};

export const getPortTabRoute = (
  fabricId?: string,
  nodeId?: string,
  portId?: string,
  tab?: string
): string => {
  return `${getPortRoute(fabricId, nodeId, portId)}/${tab}`;
};

export const getVrfRoute = (fabricId?: string, vrfId?: string): string => {
  return `${getFabricRoute(fabricId, PATHS.VRF)}/${vrfId}`;
};

export const getBgpPeerRoute = (
  fabricId: string,
  vrfId: string,
  bgpPeerId: string
): string => {
  return `${getVrfRoute(fabricId, vrfId)}/${PATHS.BGP_PEER}/${bgpPeerId}`;
};

export const getDynamicBgpPeerRoute = (
  fabricId: string,
  vrfId: string,
  deviceId: string,
  peerAddress: string,
  loopBackAddress: string
): string => {
  return `${getVrfRoute(fabricId, vrfId)}/${
    PATHS.DYNAMIC_BGP_PEER
  }/${peerAddress}/${deviceId}/${loopBackAddress}`;
};

export const getUnderlayBgpPeerRoute = (
  fabricId: string,
  bgpPeerId: string
): string => {
  return `/${PATHS.FABRIC}/${fabricId}/${PATHS.BGP_PEER}/${bgpPeerId}`;
};

export const getVniRoute = (fabricId?: string, vniId?: string): string => {
  return `${getFabricRoute(fabricId, PATHS.VNI)}/${vniId}`;
};

export const getServerRoute = (
  fabricId?: string,
  serverId?: string
): string => {
  return `${getFabricRoute(fabricId, PATHS.SERVER)}/${serverId}`;
};

export const getServerTabRoute = (
  fabricId?: string,
  serverId?: string,
  tab?: string
): string => {
  return `${getServerRoute(fabricId, serverId)}/${tab}`;
};

export const getServerPortRoute = (
  fabricId?: string,
  serverId?: string,
  portId?: string
): string => {
  return `${getServerRoute(fabricId, serverId)}/${PATHS.PORT}/${portId}`;
};

export const getPortChannelRoute = (
  fabricId?: string,
  portChannelId?: string
): string => {
  return `${getFabricRoute(fabricId, PATHS.PORT_CHANNEL)}/${portChannelId}`;
};

export const getPolicyRoute = (
  fabricId?: string,
  policyId?: string
): string => {
  return `${getFabricRoute(fabricId, PATHS.POLICY)}/${policyId}`;
};

export const getFabricTemplateRoute = (
  tab: string | undefined = PATHS.SWITCH_FABRICS
): string => {
  return `/${PATHS.FABRIC_TEMPLATES}/${tab}`;
};

export const getNotificationRoute = (
  tab: string | undefined = PATHS.NOTIFICATION_POLICIES
): string => {
  return `/${PATHS.NOTIFICATIONS}/${tab}`;
};

export const getSubscriptionRoute = (
  tab: string | undefined = PATHS.SUBSCRIPTION_MANAGEMENT
): string => {
  return `/${PATHS.SUBSCRIPTION}/${tab}`;
};

export const getEditFabricRoute = (
  fabricId: string,
  cablingDryRun?: boolean
) => {
  if (fabricId && cablingDryRun) {
    return `/fabric-designer/${fabricId}/edit?dryrun=true`;
  }
  return `/fabric-designer/${fabricId}/edit`;
};

export const getMultisiteRoute = (
  multisiteId?: string,
  tab: string | undefined = PATHS.FABRIC_INTERCONNECTS
): string => {
  return `/${PATHS.MULTISITE}/${multisiteId}/${tab}`;
};

/**
 * Unified route generator that automatically decides between fabric and multisite routes
 * based on the provided context.
 */
export const getContextRoute = (
  context: "fabric" | "multisite",
  contextId: string,
  tab?: string
): string => {
  return context === "fabric"
    ? getFabricRoute(contextId, tab)
    : getMultisiteRoute(contextId, tab);
};
